export default {
  "base": "bg-(--ui-bg-muted)"
}